import React from 'react'
import { PencilSquare } from 'react-bootstrap-icons'
import Cutoff from './cutoff'

const EnrollCutoff = ({
    value = '',
    onChange = () => {},
    disabled
}) => {
    return (<Cutoff icon={PencilSquare} label='Enroll Cutoff' value={value} onChange={onChange} disabled={disabled} />)
}

export default EnrollCutoff
